import React from 'react';
import { VerifiedAddress } from './addressVerificationTypes';

function NoSuggestionAddress(props: { address: VerifiedAddress }) {
  const { address } = props;
  const {
    primaryLine, secondaryLine, city, state, zip,
  } = address;
  return (
    <div className="av__addresses av__addresses--centered-text">
      <div className="av__address av__address--selected">
        <div className="av__address-row av__no-padding">{primaryLine}</div>
        <div className="av__address-row av__no-padding">{secondaryLine}</div>
        <div className="av__address-row av__no-padding">
          {city}
          {', '}
          {state}
          {' '}
          {zip}
        </div>
      </div>
    </div>
  );
}

export default NoSuggestionAddress;
